<template>
  <div class="agendas_box">
    <div class="loading" v-if="isLoading">
      <img src="../../assets/images/loading.gif" alt />
    </div>
    <div v-else class="a_box">
      <div :class="$i18n.locale === 'en' ? 'changeBlockId changeBlockIdEn' : 'changeBlockId'">
        <div :class="block_id === 5 ? 'btn active' : 'btn'" @click="getSchedule(5)">
          <p v-if="$i18n.locale === 'en'">Global</p>
          <p>{{$t('lang.mainstage')}}</p>
        </div>
        <div :class="block_id === 7 ? 'btn active' : 'btn'" @click="getSchedule(7)">
          <p v-if="$i18n.locale === 'en'">Global</p>
          <p>{{$t('lang.stage2')}}</p>
        </div>
      </div>
      <div>
          <div v-show="blocks[`${block_id}`]" class="country_box" v-for="(summit, index) in blocks[`${block_id}`].summits" :key="summit.id">
            <div :class="$i18n.locale === 'zh'?'country_title': 'country_title country_title_en'">
              <img src="../../assets/images/whitebg.png" alt v-if="index%2 === 0" />
              <img src="../../assets/images/colorbg.png" alt v-else />
              <div>{{summit.name}}</div>
            </div>
            <div class="country_agenda">
              <p class="country_time">{{getDate(summit.begin_time, summit.end_time)}}</p>
              <div class="agendas">
                <div class="line"></div>
                <div
                  class="agenda_box"
                  v-for="section in summit.section_topics"
                  :key="section.section_topic_id"
                  v-show="section.schedules !== null"
                >
                  <div
                    class="agenda"
                    v-for="schedule in section.schedules"
                    :key="schedule.agenda_id"
                  >
                    <p class="time">{{getTime(schedule.begin_time, schedule.end_time)}}</p>
                    <p class="title">{{schedule.topic}}</p>
                    <div class="speakers">
                      <div class="speaker" v-for="speaker in schedule.speakers" :key="speaker.id">
                        <div class="img_box">
                          <img :src="fixUrl(speaker.photo_url)" alt />
                        </div>
                        <div class="word_box">
                          <!-- <div class="name_box">{{speaker.speaker_type}}: {{speaker.name}}</div> -->
                          <div class="name_box">{{speaker.name}}</div>
                          <div class="title_box">
                            <p>{{speaker.company}}</p>
                            <p>{{speaker.title}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img
              :src="'/static/images/contact' + index%4 +'.jpg'"
              alt
              v-show="index < blocks[`${block_id}`].summits.length - 1"
              class="bottom_img"
            />
          </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
@import "agenda.less";
</style>
<script>
/* eslint-disable */
export default {
  data () {
    return {
      blocks: {},
      block_id: 5,
      isLoading: true,
    };
  },
  created() {
    this.getSchedule(5);
  },
  watch: {
    "$i18n.locale": {
      handler: function (newer, older) {
        this.getSchedule(5);
      },
      deep: true, // 开启深度监听
    },
  },
  methods: {
    getSchedule: function (num) {
      const blks = this.blocks[`${num}`]
      if(blks && blks.summits.length > 0) {
        this.block_id = num;
        return
      }
      let self = this;
      let lang = "zh-cn";
      if (self.$i18n.locale === "zh") {
        lang = "zh-cn";
      } else {
        lang = "en-us";
      }
      self.isLoading = true;
      self.$http
        .get("https://goapi.gmic.cn/api/v1/agendas?lang=" + lang)
        .then(function (res) {
          let blocks = JSON.parse(res.data.data).blocks;
          console.log(blocks);
          let block = blocks.filter((item) => item.block_id === num)[0];
          block.summits.sort(self.compare("begin_time"));

          self.blocks[`${num}`] = block 
          self.block_id = num;

          self.$nextTick(() => {
            self.isLoading = false;
          });
          // console.log(block)
        })
        .catch(function (err) {
          self.isLoading = true;
          console.log(err);
        });
    },
    compare: function (property) {
      return function (a, b) {
        let value1 = new Date(a[property]);
        let value2 = new Date(b[property]);
        return value1 - value2;
      };
    },
    getDate: function (begin, end) {
      let begindate = begin.substring(0, 10);
      let enddate = end.substring(0, 10);
      let date = "";
      if (begindate === enddate) {
        date = begindate;
      } else {
        date = begindate + "-" + enddate;
      }
      return date;
    },
    getTime: function (begin, end) {
      let time = begin.substring(11, 16) + "-" + end.substring(11, 16);
      return time;
    },
    fixUrl: function(originURL){
      return originURL.replace('http://res.', 'https://cdnres.')
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/agenda/agenda.vue